module.exports = __webpack_public_path__ + "assets/img/num.973c654b.png";